import { ReactNode } from 'react'

import { Select } from '../../../Select'
import { TakeProfitField } from '../../model'
import { Disclosure } from '../Disclosure'

import s from './styles.module.scss'

export const TakeProfitFields = ({
  onOpenChange,
  takeProfitField,
  takeProfitActive,
  onTakeProfitFieldChange,
  input,
  inputHint,
}: {
  onOpenChange: (val: boolean) => void
  takeProfitField: TakeProfitField
  takeProfitActive: boolean
  onTakeProfitFieldChange?: (value: string) => void
  input?: ReactNode
  inputHint?: ReactNode
}) => (
  <Disclosure title="Take profit" onChange={onOpenChange} isOpen={takeProfitActive}>
    <Select
      value={takeProfitField}
      onChange={onTakeProfitFieldChange}
      placeholder="Select"
      options={[
        { name: 'Amount', value: 'take_profit_amount', subname: 'Close if lose is' },
        { name: 'Distance', value: 'take_profit_distance', subname: 'Close if price goes down by' },
        { name: 'Price level', value: 'take_profit_level', subname: 'Close when price is' },
      ]}
    />

    <div className={s.inputContainer}>{input}</div>
    {inputHint}
  </Disclosure>
)
